export class PageBackground {
  id?: string;
  descr?: string;
  name?: string;
  pageGroup:string;
  tag?: string;
  uploadCode?: string;
  thumb?: string;
  preview?: string;
  original?:string;
  businessBrandTag?:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/pageBackground.ts